import { IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { DocumentIcon, PDFIcon, WarningIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { DocumentosPermitidos } from 'src/enums/EscritosLegales'
import { theme } from 'src/providers/ThemeProvider'
import { corporate } from 'src/providers/globalVars'

type Props = {
  file: string
  multiple: boolean
}

export default function RenderDocumentIcon({ file, multiple }: Props): JSX.Element {
  const { t } = useTranslation()
  if (file) {
    const extension =
      file
        .toLowerCase()
        .split('.')
        .pop() || ''
    const extensionNotAllowed = t('form.validation.extension_not_allowed')

    if (multiple && !DocumentosPermitidos.ANEXOS.includes(extension)) {
      return (
        <Tooltip title={extensionNotAllowed} placement="top" componentsProps={styles}>
          <IconButton sx={{ color: corporate.errorColor, fontSize: '21px' }}>
            <WarningIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }

    if (!multiple && !DocumentosPermitidos.PRINCIPAL.includes(extension)) {
      return (
        <Tooltip title={extensionNotAllowed} placement="top" componentsProps={styles}>
          <IconButton sx={{ color: corporate.errorColor, fontSize: '21px' }}>
            <WarningIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }

    if (extension === 'pdf') {
      return <PDFIcon sx={{ fontSize: '21px' }} />
    }
  }

  return <DocumentIcon sx={{ fontSize: '21px' }} htmlColor={theme.colors.gray14} />
}
